import Form from '../Form/Form';
import DetailPage from '../DetailPage/DetailPage';
import DetailPageMainView from '../DetailPage/DetailPageMainView';

class DetailPageMap {
    constructor() {
        this.componentMap = {
            'Form': Form,
            'DetailPage': DetailPage,
            'DetailPageMainView': DetailPageMainView,
            'FormCard': null,
            'Feed': null
        };

        this.noWrappField = [
            'Form',
            'DetailPage',
            'DetailPageMainView',
            'DetailPageRelateView'
        ];
    }

    registerComponent(key, cmp) {
        this.componentMap[key] = cmp;
    }

    getComponentMap() {
        return this.componentMap;
    }

    getNoWrapComponents() {
        return this.noWrappField;
    }
}

const DetailPageMapInstance = new DetailPageMap();
export default DetailPageMapInstance;



// WEBPACK FOOTER //
// ./src/components/DetailPage/DetailPageMap.js